<!--
 * @Author: scg
 * @Date: 2022-01-17 16:18:42
 * @LastEditTime: 2022-02-25 09:21:21
 * @LastEditors: scg
 * @Description:
-->
<template>
<div  class="fff">
  <div class="page_title">{{$t('manufacturer.title')}}</div>
  <div class="Manufacturer_ul">
    <div class="Manufacturer" @click="isshow==key?isshow=0:isshow=key"  v-for="(val,key) in list" :key="key">
      <img v-if="isshow==key" src="@/assets/img/qdui.png" alt="">
      <img v-if="isshow!=key" src="@/assets/img/qnodui.png" alt="">
      {{val.device_brand}}
    </div>
  </div>
  <div class="twoButton">
    <div @click="$router.push({path: '/Guidance'})" class="BackButton">{{$t('manufacturer.back')}}</div>
    <div @click="goSelect()" class="loginButton">{{$t('manufacturer.continue')}}</div>
  </div>
</div>
</template>

<script>
import {BindDeviceGetDeviceList} from '@/api/user'

export default {
  name: 'HelloWorld',
  data () {
    return {
      isshow: 0,
      list: [],
      msg: ''
    }
  },
  mounted () {
    this.grtlist()
  },
  methods: {
    grtlist () {
      BindDeviceGetDeviceList().then((adj) => {
        console.log(adj.data)
        this.list = adj.data
      })
    },
    goSelect () {
      this.$router.push({
        name: 'Select',
        query: {
          device_brand: this.list[this.isshow].device_brand,
          id: this.list[this.isshow].id
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.page_bo_li{margin-bottom:20px;position:relative;padding:25px 0;cursor:pointer}
.system_logo{float:left;width:20px;margin:10px 15px 0 20px}
.system_more{position:absolute;width:16px;height:16px;right:25px;top:40px}
.system_title{font-size:14px;height:16px;line-height:16px;font-weight:700;margin-bottom:5px}
.system_con{font-size:13px;height:20px;line-height:20px;color:grey}
.Manufacturer{width:290px;height:60px;line-height:60px;margin-right:20px;margin-bottom:20px;float:left;border:1px solid #e1e3e6;border-radius:12px;font-size:14px;color:#000927;cursor:pointer}
.Manufacturer img{float:left;width:20px;height:20px;margin:20px 15px 0 20px}
.Manufacturer_ul{overflow:hidden;margin-left:5%}

</style>



// WEBPACK FOOTER //
// src/components/Manufacturer.vue